<template>
    <header class="navbar-fixed-top">
        <div class="default-header">
            <div class="container">
                <div class="row">
                <div class="col-sm-3 col-md-2">
                    <div class="logo"> 
                        <a href="/">
                            <!--<img 
                            src="/assets/images/logo/logo_dark.png"
                            height="55"
                            alt="image"/>-->
                        </a> 
                        </div>
                </div>
                <div class="col-sm-9 col-md-10">
                    <div class="send_msg">
                    <button type="button" class="btn" data-toggle="modal" data-target="#contact_form_popup"> Enviar mensaje <span class="angle_arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></span> </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>